/*
This snippet is pulled into all product pages
*/

function brexitPriceBreakdown() {
  const trig = document.getElementById('brexit-price-explanation-trig');
  const modal = document.getElementById('brexit-price-explanation');
  // console.log(trig, modal)
  if (trig && modal) {
    trig.addEventListener('click', () => {
      modal.classList.add('active');
      handleFixedElements('hide');
    })
  }
}
brexitPriceBreakdown();


// $('.product-details .grid-item .title').off().click(function(e) {
//   if (window.innerWidth <= 992) {
//     e.preventDefault();
//     $(this).next('.description_content').slideToggle(mobileMenuSlideTime); // jQuery slide before adding active class
//     $(this).toggleClass('active');
//   }
// });

// $(window).resize(function() {
//   if (window.innerWidth > 992) {
//     $('.product-details .grid-item .description_content').show()
//   }
// })

const boostRelatedProducts = () => {
  try {
      const main = document.querySelector('main')
      const faqs = document.getElementById('product-faq')
      const related = document.getElementById('product-related')
      main.insertBefore(related, faqs)
  } catch (err) {
      console.log(err)
  }
}



// Open product admin using Konami
if(productId) {
  const konamiProductAdmin = [
    'up',
    'up',
    'down',
    'down',
    'left',
    'right',
    'left',
    'right',
    'a',
    'd',
    'm',
    'i',
    'n'
  ];
  let isDev = window.location.hostname.indexOf('chupi-dev') > -1;
  let storeName = isDev ? 'chupi-dev2' : 'chupi-jewellery';
  let adminUrl = `https://admin.shopify.com/store/${storeName}/products/${productId}`;
  doCustomKonamiCode(konamiProductAdmin, () => {
    window.open(adminUrl, '_blank').focus();
  })
}



// Product customise legend overlay
// let customiseLegend = document.querySelector('.customise-info .customise-legend');
// let customiseLegendOverlay = document.querySelector('.customise-info .customise-legend-overlay');
// if(customiseLegend && customiseLegendOverlay) {
//   customiseLegend.addEventListener('click', e => {
//     customiseLegendOverlay.classList.add('active');
//     handleFixedElements('hide');
//   });
// }